export default "__VITE_ASSET__CyzlGrTf__"